"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=14271%3A101))
 * @trackcomponent
 * @lastsynced 2026-09-30T17:16:17.000Z
 * @optimized using svgo:^3.3.4
 */
export const BSRCart = createSVGIcon(
  <>
    <path
      d="m20.89 7.798.73.175.222-.925h-.951zm-2.055 8.561v.75h.592l.138-.575zM5.4 3l.726-.191-.148-.559H5.4zm3.524 13.36-.726.19.148.56h.578zM2.609 2.25a.75.75 0 1 0 0 1.5v-1.5m4.04 5.548v.75H20.89v-1.5H6.648zm14.242 0-.73-.175-2.055 8.561.73.175.729.175 2.055-8.56zM5.4 3l-.726.191 3.523 13.36.726-.192.725-.19-3.523-13.36zM2.608 3v.75H5.4v-1.5H2.61zm16.226 13.36v-.75H8.924v1.5h9.911z"
      fill="currentColor"
    />
    <circle cx="10.344" cy="20.344" r="1.406" fill="currentColor" />
    <ellipse cx="17.14" cy="20.344" rx="1.405" ry="1.406" fill="currentColor" />
  </>,
  "BSRCart",
  {
    className: iconCls(),
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
